import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { companies } from "../../data/content";
import { Eyebrow, Reveal, ArrowLink } from "./motion";

const spans = [
  "md:col-span-7 md:h-[560px]",
  "md:col-span-5 md:h-[560px]",
  "md:col-span-4 md:h-[400px]",
  "md:col-span-4 md:h-[400px]",
  "md:col-span-4 md:h-[400px]",
  "md:col-span-4 md:h-[380px]",
  "md:col-span-4 md:h-[380px]",
  "md:col-span-4 md:h-[380px]",
  "md:col-span-12 md:h-[420px]",
];

export default function CapabilityGrid({ hub = false }) {
  return (
    <section className="bg-ink px-6 py-24 lg:px-12 lg:py-[140px]" aria-label="One Group, Six Capabilities">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <div>
          <Eyebrow>One Group, Nine Companies</Eyebrow>
          <h2 className="mt-5 max-w-3xl text-4xl font-extrabold tracking-tighter text-white sm:text-5xl lg:text-6xl">
            Nine companies. One connected strategy.
          </h2>
        </div>
        {!hub && (
          <ArrowLink light to="/companies" testId="capabilities-view-all">
            View All Companies
          </ArrowLink>
        )}
      </div>

      <div className="mt-16 grid grid-cols-1 gap-4 md:grid-cols-12">
        {companies.map((c, i) => (
          <Reveal key={c.slug} delay={(i % 3) * 0.08} className={`h-[320px] ${spans[i]}`}>
            <Link
              to={`/companies/${c.slug}`}
              data-testid={`capability-card-${c.slug}`}
              className="group relative block h-full w-full overflow-hidden"
            >
              <img
                src={c.image}
                alt={`${c.name} — placeholder image`}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/95 via-ink/35 to-transparent transition-opacity duration-500" />
              <div className="absolute left-5 top-5 flex gap-2">
                {hub && (
                  <span className="inline-flex items-center rounded-full border border-gold/60 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-gold">
                    {c.stage}
                  </span>
                )}
                {c.comingSoon && (
                  <span className="inline-flex items-center rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-ink">
                    Coming Soon
                  </span>
                )}
              </div>
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-6 lg:p-8">
                <div>
                  <h3 className="text-xl font-bold text-white lg:text-2xl">{c.name}</h3>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-white/60">
                    {hub ? c.tabLine : c.cardTag}
                  </p>
                </div>
                <ArrowUpRight className="h-6 w-6 shrink-0 text-gold opacity-0 transition-all duration-300 group-hover:opacity-100" />
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
